<template>
  <section id="my-hubs">
    <b-overlay :show="showContent" spinner-variant="primary" variant="transparent" blur="3px" rounded="sm">
      <b-card no-body>
        <b-table striped hover responsive class="position-relative" :current-page="myHubsTable.currentPage"
          :items="myHubsTable.items" :fields="myHubsTable.fields" :sort-by.sync="myHubsTable.sortBy"
          :sort-desc.sync="myHubsTable.sortDesc" :sort-direction="myHubsTable.sortDirection"
          :filter="myHubsTable.filter" :filter-included-fields="myHubsTable.filterOn" @row-clicked="rowClicked">
          <template #cell(process_configurations)="data">
            <b-badge v-for="item in data.value" :key="item.id" variant="light-primary">
              {{ item.process_name }}
            </b-badge>
          </template>
        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- pagination -->
          <div>
            <b-pagination v-model="myHubsTable.currentPage" :total-rows="myHubsTable.totalRows" first-number last-number
              prev-class="prev-item" next-class="next-item" class="mb-0" @change="handlePageChange">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-card>
    </b-overlay>
  </section>
</template>

<script>
import {
  BCard,
  BTable,
  BBadge,
  BPagination,
  BCardBody,
  BOverlay,
} from "bootstrap-vue"
import axios from "axios"

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BPagination,
    BCardBody,
    BOverlay,
  },
  data() {
    return {
      showContent: true,
      myHubsTable: {
        totalRows: 1,
        currentPage: 1,
        sortBy: "id",
        sortDesc: true,
        sortDirection: "desc",
        filter: null,
        filterOn: [],
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
          { key: "id", label: "id", sortable: true },
          { key: "name", label: "name", sortable: true },
          { key: "ofn_id", label: "ofn id", sortable: true },
          { key: "process_configurations", label: "processes", sortable: true },
          {
            key: "orders_close_at",
            label: "Orders close at",
            sortable: true,
            formatter: value => {
              let new_date = new Date(value)
              if (value) {
                return new_date.toLocaleString("de-DE", {
                  timeZone: "Europe/Berlin"
                })
              }
              else {
                return ""
              }
            }
          },
        ],
        /* eslint-disable global-require */
        items: [],
      },
      queryParams: {},
    }
  },
  methods: {
    rowClicked(row) {
      this.$router.push({ name: "hub-details", params: { id: row["id"] } })
    },
    async getMyHubs() {
      await axios
        .get(process.env.VUE_APP_ROOT_API + "/hubs/", {
          headers: {
            "Authorization": `JWT ${this.$store.state.jwt}`,
            "Content-Type": "application/json"
          },
          params: this.queryParams,
        })
        .then(response => {
          this.myHubsTable.items = response.data.results
          this.myHubsTable.totalRows = response.data.count * 2
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$router.push({ name: "login" })
          }
        })
    },
    async handlePageChange(value) {
      this.showContent = true
      this.queryParams["page"] = value
      await this.getMyHubs()
      this.showContent = false
    }
  },
  async created() {
    this.showContent = true
    Promise.all([
      await this.getMyHubs()
    ]).finally(() => {
      this.showContent = false
    })
  }
}
</script>

<style></style>
